export const SHOW_MODAL = '@@modal/SHOW_MODAL'
export const HIDE_MODAL = '@@modal/HIDE_MODAL'

interface BaseModalContext {
	type: string
}

export const DeleteActivityModalContextType = 'DeleteActivityModalContextType'
export const ImageSelectModalContextType = 'ImageSelectModalContextType'
export const CalcOptionsModalContextType = 'CalcOptionsModalContextType'
export const ShareModalContextType = 'ShareMoaelContextType'
export const ClearTagCloudModalContextType = 'ClearTagCloudModalContextType'
export const FilterTagCloudModalContextType = 'FilterTagCloudModalContextType'
export const AreYouSureModalContextType = 'AreYouSureModalContextType'
export const UnsplashModalContextType = 'UnsplashModalContextType'

export interface UnsplashModalContext extends BaseModalContext {
	type: typeof UnsplashModalContextType
	selectImage: (image: string) => void
}

export interface AreYouSureModalContext extends BaseModalContext {
	type: typeof AreYouSureModalContextType
	handleConfirm: () => Promise<void>
	confirmText: string
	confirmBody: string
}
export interface ClearTagCloudModalContext extends BaseModalContext {
	type: typeof ClearTagCloudModalContextType
	clearCloudDelete: () => void
}
export interface ShareModelContext extends BaseModalContext {
	type: typeof ShareModalContextType
	code: string | undefined
	onPin: () => void
}
export interface CalcOptionsModalContext extends BaseModalContext {
	type: typeof CalcOptionsModalContextType
	changeDifficulty: (level: number) => void
}
export interface ImageSelectModalContext extends BaseModalContext {
	type: typeof ImageSelectModalContextType
	selectImage: (backgroundImage: string, backgroundSearch: string) => void
}

export interface DeleteActivityModalContext extends BaseModalContext {
	type: typeof DeleteActivityModalContextType
	activity: string
}

export type ModalContext =
	| ClearTagCloudModalContext
	| ShareModelContext
	| CalcOptionsModalContext
	| DeleteActivityModalContext
	| ImageSelectModalContext
	| UnsplashModalContext
	| undefined

export interface ModalState {
	name: string
	context?: ModalContext
	sticky: boolean
}

export interface Modal {
	name: string
	context?: ModalContext
	sticky?: boolean
}

interface ShowModalAction {
	type: typeof SHOW_MODAL
	payload: Modal
}

interface HideModalAction {
	type: typeof HIDE_MODAL
}

export type ModalActionTypes = ShowModalAction | HideModalAction
